import request from '@/config/axios'

// interface params {
//   // corpid: string
//   url?: string
// }

export const getUserInfo = (): Promise<IResponse<any>> => {
  return request.get({ url: 'admin/getUserInfo' })
}
